import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=463d0478&scoped=true"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=463d0478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463d0478",
  null
  
)

export default component.exports